import React from "react";
import productImg from "../../Assets/8th_slider/pngegg (3) 1.png";
import Personal_slider from "./Personal_slider";

const products = Array(6).fill({
  name: "Episoft Cleansing Lotion",
  size: "250ml",
  mrp: "₹ 820.00",
  price: "₹ 697.00",
  
  discount: "15%",
  image: productImg,
});

const EssentialsOfWeek = () => {
  return (
    <>
    <section className="w-full py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4">

        {/* Header */}
        <div className="flex items-start justify-between mb-8">
          <div>
            <h2 className="text-2xl sm:text-3xl font-medium text-black">
              Essentials of the Week
            </h2>
            <p className="text-gray-400 mt-1 text-sm sm:text-base">
              Super charge your immunity with us
            </p>
          </div>

          <button className="text-[#187685] text-lg sm:text-xl font-medium">
            View All
          </button>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((item, index) => (
            <div
              key={index}
              className="flex gap-4 items-start"
            >
              {/* Image Box */}
              <div className="w-[130px] h-[130px] bg-[#FAFAFA] rounded-lg flex items-center justify-center">
                <img
                  src={item.image}
                  alt="product"
                  className="w-[95px] h-[95px] object-contain"
                />
              </div>

              {/* Content */}
              <div className="flex-1">
                <h3 className="text-[16px] sm:text-[18px] font-medium text-[#060A0B] leading-snug">
                  {item.name}
                </h3>
                <p className="text-sm text-gray-500 mb-2">{item.size}</p>

                <p className="text-sm text-gray-400 line-through">
                  MRP {item.mrp}
                </p>

                <p className="text-lg font-medium text-[#060A0B]">
                  {item.price}{" "}
                  <span className="text-red-500">({item.discount})</span>
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
    {/* <Personal_slider/> */}
    </>
  );
};

export default EssentialsOfWeek;
